/* VO2 Atelier — Product Page Configurator
   Live frame + mat colour preview with personalisation preview
   Version 1.0 — for Horizon theme */

(function() {
  'use strict';

  // ── CONFIGURATION ──
  const FRAME_COLORS = {
    'Matte Black': '#1A1A18',
    'Natural Oak': '#C8A87A',
    'Matte White': '#F0EDE8'
  };

  const MAT_COLORS = {
    'White': { bg: '#FFFFFF', text: '#333333' },
    'Cream': { bg: '#F5F0E8', text: '#333333' },
    'Black': { bg: '#1A1A18', text: '#C0AA27' },
    'Navy':  { bg: '#1C2233', text: '#C0AA27' }
  };

  const ADDON_PRICES = {
    personalisation: 8,
    qr: 5
  };

  const BASE_PRICE = 45;
  const COMPARE_PRICE = 65;
  const MAX_CHARS = 28;

  // ── STATE ──
  let state = {
    frameColor: 'Matte Black',
    matColor: 'White',
    personalisation: false,
    persName: '',
    persRace: '',
    persDate: '',
    persTime: '',
    qr: false,
    qrUrl: ''
  };

  // ── INJECT HTML ──
  function injectConfigurator() {
    const productForm = document.querySelector('product-form, form[action*="/cart/add"], .product-form, [data-type="add-to-cart-form"]');
    if (!productForm) return;

    const container = document.createElement('div');
    container.id = 'vo2-configurator';
    container.innerHTML = `
      <div class="vo2-config-wrap">

        <!-- LIVE PREVIEW -->
        <div class="vo2-preview-section">
          <p class="vo2-preview-label">Live Preview</p>
          <div class="vo2-frame-preview" id="vo2-frame">
            <div class="vo2-mat" id="vo2-mat">
              <div class="vo2-medal-zone">
                <div class="vo2-medal-placeholder">
                  <span class="vo2-medal-icon">✦</span>
                  <span class="vo2-medal-text">Your medal here</span>
                </div>
              </div>
              <div class="vo2-dedication" id="vo2-dedication" style="display:none;">
                <span id="vo2-ded-text"></span>
              </div>
              <div class="vo2-qr-preview" id="vo2-qr-preview" style="display:none;">
                <div class="vo2-qr-icon">⬛</div>
              </div>
            </div>
          </div>
          <p class="vo2-preview-note" id="vo2-config-summary">Matte Black · White mat · $45</p>
        </div>

        <!-- CONTROLS -->
        <div class="vo2-controls-section">

          <!-- Frame Colour -->
          <div class="vo2-option-group">
            <label class="vo2-option-label">Frame Colour <span class="vo2-selected-label" id="frame-selected">Matte Black</span></label>
            <div class="vo2-swatches" id="frame-swatches">
              <button type="button" class="vo2-swatch vo2-swatch-active" data-frame="Matte Black" style="background:#1A1A18;" title="Matte Black"></button>
              <button type="button" class="vo2-swatch" data-frame="Natural Oak" style="background:linear-gradient(135deg,#C8A87A,#A0784A);" title="Natural Oak"></button>
              <button type="button" class="vo2-swatch" data-frame="Matte White" style="background:#F0EDE8;border:1px solid #ccc;" title="Matte White"></button>
            </div>
          </div>

          <!-- Mat Colour -->
          <div class="vo2-option-group">
            <label class="vo2-option-label">Mat Colour <span class="vo2-selected-label" id="mat-selected">White</span></label>
            <div class="vo2-swatches" id="mat-swatches">
              <button type="button" class="vo2-swatch vo2-swatch-active" data-mat="White" style="background:#FFFFFF;border:1px solid #ccc;" title="White"></button>
              <button type="button" class="vo2-swatch" data-mat="Cream" style="background:#F5F0E8;" title="Cream"></button>
              <button type="button" class="vo2-swatch" data-mat="Black" style="background:#1A1A18;" title="Black"></button>
              
            </div>
          </div>

          <!-- Personalisation -->
          <div class="vo2-option-group">
            <label class="vo2-addon-toggle">
              <input type="checkbox" id="vo2-pers-check" name="properties[Personalisation]" value="Yes"/>
              <span class="vo2-addon-title">Add Personalisation <span class="vo2-addon-price">+$8</span></span>
             <span class="vo2-addon-desc">Your name · race · date · your achievement</span>
            </label>
            <div class="vo2-pers-fields" id="vo2-pers-fields" style="display:none;">
              <div class="vo2-field-row">
                <div class="vo2-field-wrap">
                  <label>Your name <span class="vo2-char-count" id="name-count">0/20</span></label>
                  <input type="text" name="properties[Name]" id="vo2-name" placeholder="e.g. Manuel Melkonian" maxlength="20" autocomplete="off"/>
                </div>
                <div class="vo2-field-wrap">
                  <label>Race / Event <span class="vo2-char-count" id="race-count">0/20</span></label>
                  <input type="text" name="properties[Race]" id="vo2-race" placeholder="e.g. Beirut Marathon" maxlength="20" autocomplete="off"/>
                </div>
              </div>
              <div class="vo2-field-row">
                <div class="vo2-field-wrap">
                  <label>Date <span class="vo2-char-count" id="date-count">0/12</span></label>
                  <input type="text" name="properties[Date]" id="vo2-date" placeholder="e.g. 09.11.2025" maxlength="12" autocomplete="off"/>
                </div>
                <div class="vo2-field-wrap">
                  <label>Achievement <span class="vo2-char-count" id="time-count">0/20</span></label>
                  <input type="text" name="properties[Achievement]" id="vo2-time" placeholder="e.g. 3:42:17 · 1st place · New PR" maxlength="20" autocomplete="off"/>
                </div>
              </div>
            </div>
          </div>

          <!-- QR Code -->
          <div class="vo2-option-group">
            <label class="vo2-addon-toggle">
              <input type="checkbox" id="vo2-qr-check" name="properties[QR Code]" value="Yes"/>
              <span class="vo2-addon-title">Add QR Code <span class="vo2-addon-price">+$5</span></span>
              <span class="vo2-addon-desc">Scan to relive the moment — links to Strava, photos, or a video message</span>
            </label>
            <div class="vo2-qr-field" id="vo2-qr-field" style="display:none;">
              <div class="vo2-field-wrap">
                <label>Your URL</label>
                <input type="url" name="properties[QR URL]" id="vo2-qr-url" placeholder="https://strava.com/activities/... or any link" autocomplete="off"/>
              </div>
            </div>
          </div>

          <!-- Price summary -->
          <div class="vo2-price-summary">
            <span class="vo2-price-compare">$65</span>
            <span class="vo2-price-current" id="vo2-price">$45</span>
            <span class="vo2-price-save" id="vo2-save-badge">Save 30%</span>
          </div>

          <!-- Hidden inputs for frame/mat selection -->
          <input type="hidden" name="properties[Frame Colour]" id="vo2-frame-input" value="Matte Black"/>
          <input type="hidden" name="properties[Mat Colour]" id="vo2-mat-input" value="White"/>

        </div>
      </div>
    `;

    productForm.insertAdjacentElement('beforebegin', container);
    initEvents();
    updatePreview();
  }

  // ── EVENTS ──
  function initEvents() {
    // Frame swatches
    document.querySelectorAll('[data-frame]').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('[data-frame]').forEach(b => b.classList.remove('vo2-swatch-active'));
        this.classList.add('vo2-swatch-active');
        state.frameColor = this.dataset.frame;
        document.getElementById('frame-selected').textContent = state.frameColor;
        document.getElementById('vo2-frame-input').value = state.frameColor;
        updatePreview();
      });
    });

    // Mat swatches
    document.querySelectorAll('[data-mat]').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('[data-mat]').forEach(b => b.classList.remove('vo2-swatch-active'));
        this.classList.add('vo2-swatch-active');
        state.matColor = this.dataset.mat;
        document.getElementById('mat-selected').textContent = state.matColor;
        document.getElementById('vo2-mat-input').value = state.matColor;
        updatePreview();
      });
    });

    // Personalisation toggle
    document.getElementById('vo2-pers-check').addEventListener('change', function() {
      state.personalisation = this.checked;
      document.getElementById('vo2-pers-fields').style.display = this.checked ? 'block' : 'none';
      updatePrice();
      updatePreview();
    });

    // Personalisation fields — live preview + char count
    ['vo2-name','vo2-race','vo2-date','vo2-time'].forEach(id => {
      const el = document.getElementById(id);
      const countId = id.replace('vo2-','') + '-count';
      const maxLen = parseInt(el.getAttribute('maxlength'));
      el.addEventListener('input', function() {
        state['pers' + id.replace('vo2-','').replace('-','').replace(/^(.)/, c => c.toUpperCase())] = this.value;
        const countEl = document.getElementById(countId);
        if(countEl) countEl.textContent = this.value.length + '/' + maxLen;
        if(this.value.length > maxLen * 0.8) countEl.style.color = '#C0AA27';
        else countEl.style.color = '';
        updatePreview();
      });
    });

    // QR toggle
    document.getElementById('vo2-qr-check').addEventListener('change', function() {
      state.qr = this.checked;
      document.getElementById('vo2-qr-field').style.display = this.checked ? 'block' : 'none';
      document.getElementById('vo2-qr-preview').style.display = this.checked ? 'flex' : 'none';
      updatePrice();
      updatePreview();
    });

    document.getElementById('vo2-qr-url').addEventListener('input', function() {
      state.qrUrl = this.value;
    });
  }

  // ── UPDATE PREVIEW ──
  function updatePreview() {
    const frame = document.getElementById('vo2-frame');
    const mat = document.getElementById('vo2-mat');
    if(!frame || !mat) return;

    // Frame colour
    const frameColor = FRAME_COLORS[state.frameColor] || '#1A1A18';
    frame.style.background = frameColor;
    frame.style.boxShadow = `0 20px 60px rgba(0,0,0,0.5), inset 0 0 0 4px ${frameColor}`;

    // Mat colour
    const matConfig = MAT_COLORS[state.matColor] || MAT_COLORS['White'];
    mat.style.background = matConfig.bg;

    // Dedication strip
    const ded = document.getElementById('vo2-dedication');
    const dedText = document.getElementById('vo2-ded-text');
    if(state.personalisation) {
      const parts = [
        document.getElementById('vo2-name')?.value,
        document.getElementById('vo2-race')?.value,
        document.getElementById('vo2-date')?.value,
        document.getElementById('vo2-time')?.value
      ].filter(v => v && v.trim());

      if(parts.length > 0) {
        ded.style.display = 'flex';
        dedText.textContent = parts.join(' · ');
        dedText.style.color = matConfig.text;
        ded.style.borderTop = `1px solid ${matConfig.text === '#C0AA27' ? 'rgba(192,170,39,0.3)' : 'rgba(0,0,0,0.1)'}`;
      } else {
        ded.style.display = 'flex';
        dedText.textContent = 'Your dedication here';
        dedText.style.color = 'rgba(0,0,0,0.2)';
      }
    } else {
      ded.style.display = 'none';
    }

    // QR preview
    const qrPreview = document.getElementById('vo2-qr-preview');
    if(qrPreview) qrPreview.style.display = state.qr ? 'flex' : 'none';

    // Summary label
    const summary = document.getElementById('vo2-config-summary');
    if(summary) {
      const price = BASE_PRICE + (state.personalisation ? ADDON_PRICES.personalisation : 0) + (state.qr ? ADDON_PRICES.qr : 0);
      summary.textContent = state.frameColor + ' · ' + state.matColor + ' mat · $' + price;
    }
  }

  // ── UPDATE PRICE ──
  function updatePrice() {
    let total = BASE_PRICE;
    if(state.personalisation) total += ADDON_PRICES.personalisation;
    if(state.qr) total += ADDON_PRICES.qr;

    const priceEl = document.getElementById('vo2-price');
    if(priceEl) priceEl.textContent = '$' + total + '.00';

    const saveEl = document.getElementById('vo2-save-badge');
    const saving = COMPARE_PRICE - total;
    const pct = Math.round((saving / COMPARE_PRICE) * 100);
    if(saveEl) saveEl.textContent = 'Save ' + pct + '%';
  }

  // ── INIT ──
  function init() {
    if(document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectConfigurator);
    } else {
      injectConfigurator();
    }
  }

  init();

})();